export const LOCAL_STORAGE_KEY = {
  profile: 'profile',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  userRoutes: 'userRoutes',
  classList: 'classList',
  currentBranch: 'currentBranch',
  currentBranchName: 'currentBranchName',
  authToken: 'authToken',
  ticketColumns: 'ticketColumns',
  kibanaInfoLogsEnabled: 'kibanaInfoLogsEnabled',
  // Base namespace for remembering the selected dashboard type per view.
  // Actual keys are suffixed per view (e.g. `selectedDashboardType:board`) via
  // utils/dashboardTypePreference.js.
  selectedDashboardType: 'selectedDashboardType',
};
